import { Provider } from 'react-redux';
import { App as AntdApp, ConfigProvider } from 'antd';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource-variable/inter';
import '@fontsource-variable/inter/wght-italic.css';
import './index.scss';
import ruRU from 'antd/lib/locale/ru_RU';
import dayjs from 'dayjs';
import App from './App';
import NotificationInstanceBinder from '@components/Global/NotificationInstanceBinder';
import reportWebVitals from './reportWebVitals';
import 'dayjs/locale/ru';
import './i18n';

import { setupStore } from './store';

dayjs.locale('ru');

const store = setupStore();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ConfigProvider
    locale={ruRU}
    theme={{
      token: {
        colorPrimary: '#ffb700',
        fontFamily:
          "'Inter Variable', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
      },
      components: {
        Table: {
          headerColor: '#011957',
        },
      },
    }}
  >
    <AntdApp component={false}>
      <NotificationInstanceBinder />
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </AntdApp>
  </ConfigProvider>
);

reportWebVitals();
